import { css, CSSResult } from 'lit'
import {
  csColorBackground,
  csColorFunctional,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


const cseToggleIconSize = css`${csSpacing.spacing07}`
const cseTogglePadding = css`${csSpacing.spacing01}`

export const cseToggle = {
  width: css`var(--cse-toggle-width, 42px)`,
  height: css`var(--cse-toggle-height, 24px)`,
  padding: css`var(--cse-toggle-padding, ${cseTogglePadding})`,
  backgroundColor: css`var(--cse-toggle-background-color, ${csColorBackground.disabled})`,
  backgroundColorHover: css`var(--cse-toggle-background-color-hover, ${csColorBackground.muted})`,
  borderWidth: css`var(--cse-toggle-border-width, ${csBorder.width})`,
  shadow: css`var(--cse-toggle-shadow, ${csShadow.downSmall})`,
  opacityDisabled: css`var(--cse-toggle-opacity-disabled, 0.6)`,
  color: css`var(--cse-toggle-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-toggle-color-disabled, ${csFormControl.colorDisabled})`,
  fontFamily: css`var(--cse-toggle-font-family, ${csFormControl.fontFamily})`,
  fontSize: css`var(--cse-toggle-font-size, ${csFormControl.fontSize})`,

  iconPadding: css`var(--cse-toggle-icon-padding, ${csSpacing.spacing02})`,
  iconColor: css`var(--cse-toggle-icon-color, ${csColorText.muted})`,
  iconBackgroundColor: css`var(--cse-toggle-icon-background-color, ${csFormControl.backgroundColor})`,
  iconHeight: css`var(--cse-toggle-icon-height, ${cseToggleIconSize})`,
  iconWidth: css`var(--cse-toggle-icon-width, ${cseToggleIconSize})`,
  iconPositionLeft: css`var(--cse-toggle-icon-position-left, ${cseTogglePadding})`,

  checkedBackgroundColor: css`var(--cse-toggle-checked-background-color, ${csColorFunctional.info})`,
  checkedBackgroundColorHover: css`var(--cse-toggle-checked-background-color-hover, ${csColorFunctional.infoHover})`,

  checkedIconColor: css`var(--cse-toggle-checked-icon-color, ${csColorFunctional.info})`,
  checkedIconBackgroundColor: css`var(--cse-toggle-checked-icon-background-color, ${csFormControl.backgroundColor})`,
  checkedIconPositionLeft: css`var(--cse-toggle-checked-icon-position-left, ${csSpacing.spacing07})`,
}

export const style: CSSResult = css`
  .cse-toggle {
    align-items: center;
    display: inline-flex;
  }

  input {
    display: none;
    height: 0;
    margin: 0;
    overflow: visible;
    position: static;
    width: 0;
  }

  .icon-circle {
    position: absolute;
    top: 50%;
    bottom: 50%;
    left: ${cseToggle.iconPositionLeft};
    transform: translateY(-50%);
    height: ${cseToggle.iconHeight};
    width: ${cseToggle.iconWidth};
    border-radius: 50%;
    background: ${cseToggle.iconBackgroundColor};
    color: ${cseToggle.iconColor};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${cseToggle.iconPadding};
    box-shadow: ${cseToggle.shadow};
    transition-duration: ${csTransition.duration};
    transition-property: left;
    transition-timing-function: linear;
  }

  .toggle {
    position: relative;
    width: ${cseToggle.width};
    height: ${cseToggle.height};
    border-radius: calc(${cseToggle.width} / 2);
    background: ${cseToggle.backgroundColor};
    cursor: pointer;

    transition-duration: ${csTransition.duration};
    transition-property: background-color;
    transition-timing-function: linear;
  }

  .label {
    color: ${cseToggle.color};
    font-family: ${cseToggle.fontFamily};
    font-size: ${cseToggle.fontSize};
    display: inline-block;
    line-height: normal;
    margin-right: 10px;
    user-select: none;
    vertical-align: top;
    cursor: pointer;
  }

  .disabled .label {
    color: ${cseToggle.colorDisabled};
  }

  .cse-toggle.disabled {
    pointer-events: none;
  }

  .cse-toggle.disabled .toggle {
    pointer-events: none;
    opacity: ${cseToggle.opacityDisabled};
  }

  .cse-toggle.checked .toggle {
    background: ${cseToggle.checkedBackgroundColor};
  }

  .cse-toggle.checked .icon-circle {
    background: ${cseToggle.checkedIconBackgroundColor};
    left: ${cseToggle.checkedIconPositionLeft};
    color: ${cseToggle.checkedIconColor};
  }

  .cse-toggle.checked:hover .toggle {
    background: ${cseToggle.checkedBackgroundColorHover};
  }

  .cse-toggle:not(.checked):hover .toggle {
    background: ${cseToggle.backgroundColorHover};
  }
`
